import React, { useContext, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Input } from '@thd-olt-component-react/input';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import { JobPostingContext } from '../../contexts/JobPostingContext';
import { NAME_CHAR_LIMIT, DESCRIPTION_CHAR_LIMIT } from '../../utils/constants';
import Field from '../common/Field/Field';
import { jobPostingValidators } from '../../utils/validations';
import { calculateTextBoxRows } from '../../utils/formatters';

const CompanyProfile = observer(({ showErrors }) => {
  const { editedJobPosting, updateJobPostingField } = useContext(JobPostingContext);
  const [isCompanyNameDirty, setIsCompanyNameDirty] = useState(false);

  return (
    <>
      <Row>
        <Col>
          <Field
            label="Company Name"
            description="Please enter your company name"
            required
            dirty={isCompanyNameDirty}
            showError={(isCompanyNameDirty || showErrors.draft || showErrors.publish) && !jobPostingValidators.companyName(editedJobPosting)}
          >
            <Input
              required
              validateOnBlur
              value={editedJobPosting?.companyName || ''}
              maxLength={NAME_CHAR_LIMIT}
              onChange={(newValue) => {
                setIsCompanyNameDirty(true);
                updateJobPostingField('companyName', newValue);
              }}
              validation={() => jobPostingValidators.companyName(editedJobPosting)}
              errorText="Please provide your company name"
              name="companyName"
            />
          </Field>
        </Col>
      </Row>
      <Row>
        <Col>
          <Field
            label="Company URL"
            description="Please enter your company url"
            dirty={jobPostingValidators.companyUrl(editedJobPosting)}
            showError={!jobPostingValidators.companyUrl(editedJobPosting)}
          >
            <Input
              validateOnBlur={!!editedJobPosting?.companyUrl}
              value={editedJobPosting?.companyUrl}
              maxLength={NAME_CHAR_LIMIT}
              onChange={(newValue) => updateJobPostingField('companyUrl', newValue)}
              validation={() => jobPostingValidators.companyUrl(editedJobPosting)}
              errorText="Please provide a valid url"
              name="companyUrl"
            />
          </Field>
        </Col>
      </Row>
      <Row>
        <Col>
          <Field
            label="Company Description"
            description="Describe your company and the type of work it provides."
            id="companyDescription"
          >
            <Input
              type="textarea"
              name="companyDescription"
              value={editedJobPosting?.companyDescription}
              maxLength={DESCRIPTION_CHAR_LIMIT}
              onChange={(newValue) => updateJobPostingField('companyDescription', newValue)}
              rows={calculateTextBoxRows(editedJobPosting?.companyDescription, 5, document?.getElementById('companyDescription')?.getBoundingClientRect()?.width)}
            />
          </Field>
        </Col>
      </Row>
      <Row>
        <p className="create-job-posting__time-bound">
          All postings should align to local and state employment laws.
        </p>
      </Row>
    </>
  );
});

export default CompanyProfile;
